import React, {useEffect} from 'react';

type Options = {
	error?: string | boolean;
	inputRef: React.RefObject<HTMLInputElement | null | undefined>;
};

const IGNORE = ['INPUT', 'SELECT'];

/**
 * @deprecated use react-hook-form focus instead
 */
export const useErrorFocus = ({error, inputRef}: Options) => {
	useEffect(() => {
		if (
			error == null ||
			error === false ||
			(document.activeElement &&
				IGNORE.includes(document.activeElement?.nodeName))
		)
			return;

		inputRef.current?.focus();
	}, [error]);
};

export default useErrorFocus;
